// extracted by mini-css-extract-plugin
export default {"content":"InformationPage_content__ehVPQ","text":"InformationPage_text__DvL5K"};